var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dd-section"},[_c('div',{staticClass:"dd-section__title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('div',{staticClass:"dd-section__body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }